import { render, staticRenderFns } from "./AutoRenew.vue?vue&type=template&id=53757038&"
import script from "./AutoRenew.vue?vue&type=script&lang=js&"
export * from "./AutoRenew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports